import React from 'react';

import { type TSpacerBlock } from '@wp-block-builder/blocks/Spacer';
import { generateRandomBlockId } from '@wp-block-builder/package';

import BlockTypeIcon from '../../../../../blocks/helpers/BlockTypeIcon';

import defineBlockButton from './helpers/defineBlockButton';

const getDefaultProps: () => TSpacerBlock = () => ({
  id: generateRandomBlockId(),
  type: 'Spacer',
  style: {},
  props: { height: 16 },
  sectionProps: {},
});

export default defineBlockButton<TSpacerBlock>({
  label: 'Spacer',
  icon: <BlockTypeIcon type="Spacer" />,
  defaultBlock: getDefaultProps,
  defaultContainerBlock: getDefaultProps,
  defaultColumnBlock: getDefaultProps,
});
